import { Suspense } from 'react';
import { QueryErrorBoundary } from '@sara/ui/components/query-error-boundary';
import { Skeleton } from '@sara/ui/components/skeleton';
import { DomainListContainerContent } from './DomainListContainerContent';
import type { DomainListContainerProps } from './types';

export type { DomainListContainerProps };

function DomainListSkeleton() {
  return (
    <div className="space-y-4">
      <Skeleton className="h-3 w-32" />
      <div className="divide-y divide-border/70 border-y border-border/70">
        {[0, 1].map((i) => (
          <div key={i} className="flex items-center justify-between gap-5 py-5">
            <div className="flex-1 space-y-2">
              <Skeleton className="h-4 w-48" />
              <Skeleton className="h-3 w-72" />
            </div>
            <Skeleton className="h-6 w-20 rounded-full" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function DomainListContainer(props: DomainListContainerProps) {
  return (
    <QueryErrorBoundary>
      <Suspense fallback={<DomainListSkeleton />}>
        <DomainListContainerContent {...props} />
      </Suspense>
    </QueryErrorBoundary>
  );
}
